import { render, staticRenderFns } from "./DataChecking.vue?vue&type=template&id=75bba126&scoped=true"
import script from "./DataChecking.vue?vue&type=script&lang=js"
export * from "./DataChecking.vue?vue&type=script&lang=js"
import style0 from "./DataChecking.vue?vue&type=style&index=0&id=75bba126&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bba126",
  null
  
)

export default component.exports